import { render } from "./add-store-locator.vue?vue&type=template&id=1a37ce9b"
import script from "./add-store-locator.vue?vue&type=script&lang=js"
export * from "./add-store-locator.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/tap-apps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__